/**
 * Based on the current environment, returns the base public asset path
 * @summary Returns the base public asset path. By default it returns assets located within this project. However, if passed isContainerAppAssetPath=true, it will return the path to the container app assets.
 * @param {String} path - The path to the public asset
 * @param {Boolean} isContainerAppAsset - Should the return path be for the assets in wl-toggle-container?
 * @return {String} A base path to the public assets
 */
export function buildPublicAssetPath(
  path: string = '',
  isContainerAppAsset: boolean = false
): string {
  if (isContainerAppAsset) {
    return path;
  }

  if (process.env.REACT_APP_ENV === 'development') {
    return `http://localhost:${process.env.REACT_APP_PORT}/${path}`;
  }

  if (process.env.REACT_APP_IS_E2W === 'true') {
    return `/auto/${path}`;
  }

  return `${process.env.PUBLIC_URL}/auto/${path}`;
}
